import React from 'react';

const Code = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M19.6923 6.39999C20.2078 6.59825 20.4649 7.17684 20.2667 7.69232L13.6 25.0257C13.4018 25.5411 12.8232 25.7983 12.3077 25.6C11.7922 25.4018 11.5351 24.8232 11.7333 24.3077L18.4 6.97436C18.5982 6.45889 19.1768 6.20173 19.6923 6.39999ZM10.0404 11.2929C10.431 11.6834 10.431 12.3166 10.0404 12.7071L6.74755 16L10.0404 19.2929C10.431 19.6834 10.431 20.3166 10.0404 20.7071C9.64992 21.0976 9.01675 21.0976 8.62623 20.7071L4.62623 16.7071C4.2357 16.3166 4.2357 15.6834 4.62623 15.2929L8.62623 11.2929C9.01675 10.9024 9.64992 10.9024 10.0404 11.2929ZM21.9596 11.2929C22.3501 10.9024 22.9832 10.9024 23.3738 11.2929L27.3738 15.2929C27.7643 15.6834 27.7643 16.3166 27.3738 16.7071L23.3738 20.7071C22.9832 21.0976 22.3501 21.0976 21.9596 20.7071C21.569 20.3166 21.569 19.6834 21.9596 19.2929L25.2525 16L21.9596 12.7071C21.569 12.3166 21.569 11.6834 21.9596 11.2929Z" />
  </svg>
);

export default Code;
